<template>
  <div>
    <div class="tw-flex tw-items-start">
      <base-select
        label="Program"
        placeholder="Select a program"
        :optgroups="programs"
        label-key="name"
        value-key="businessProgramId"
        :value="value.businessProgramId"
        @input="updatePrescriptionProgram"
        :required="required"
        class="tw-flex-grow"
      />
      <base-icon color="red" :class="['tw-mt-2 tw-ml-2', { 'tw-invisible': !value.businessProgramId }]" @click="updatePrescriptionProgram(null)">
        <x-icon class="tw-w-5 tw-h-5" />
      </base-icon>
    </div>
    <div v-if="selectedProgram" class="tw-pl-6 tw-mt-4">
      <div v-for="medicationIndex in selectedProgram.maxMedications" :key="medicationIndex" class="tw-flex tw-items-start">
        <base-select
          :label="`Medication ${medicationIndex}`"
          placeholder="Select a medication"
          :optgroups="sortedMedications"
          label-key="name"
          value-key="businessItemCategoryId"
          :value="value.medications[medicationIndex - 1]"
          @input="updatePrescriptionMedications(medicationIndex - 1, $event)"
          class="tw-mt-1"
          :rules="[(med) => value.medications.filter((m) => med === m).length <= 1 || 'Remove duplicates']"
        />
        <base-icon
          color="red"
          :class="['tw-mt-2.5 tw-ml-2', { 'tw-invisible': !value.medications[medicationIndex - 1] }]"
          @click="updatePrescriptionMedications(medicationIndex - 1, null)"
        >
          <x-icon class="tw-w-5 tw-h-5" />
        </base-icon>
      </div>
      <base-textarea class="tw-mt-6 tw-mb-5 tw-mr-9" label="Program Notes" placeholder="Enter program notes" :value="value.notes" @input="updatePrescriptionNotes" />
    </div>
  </div>
</template>

<script>
import { XIcon } from "@/assets/svgs";
import { cloneDeep, uniq, orderBy } from "lodash";

export default {
  components: {
    XIcon,
  },
  props: {
    value: Object,
    programs: Array,
    required: Boolean,
  },
  computed: {
    selectedProgram() {
      return this.programs
        .map((pg) => pg.options)
        .flat()
        .find((p) => p.businessProgramId === this.value.businessProgramId);
    },
    sortedMedications() {
      if (!this.selectedProgram) return [];
      const groups = orderBy(uniq(this.selectedProgram.allowedMedications.map((m) => m.productGroup)));

      return groups.map((g) => ({
        label: g,
        options: orderBy(this.selectedProgram.allowedMedications.filter((m) => m.productGroup === g), ["name"]),
      }));
    },
  },
  methods: {
    updatePrescriptionProgram(businessProgramId) {
      const copy = cloneDeep(this.value);
      copy.businessProgramId = businessProgramId;
      copy.medications = [];
      this.$emit("input", copy);
    },
    updatePrescriptionMedications(medicationIndex, businessItemCategoryId) {
      const copy = cloneDeep(this.value);
      copy.medications[medicationIndex] = businessItemCategoryId;
      this.$emit("input", copy);
    },
    updatePrescriptionNotes(event) {
      const copy = cloneDeep(this.value);
      copy.notes = event;
      this.$emit("input", copy);
    },
  },
};
</script>
